export default {
    userInfo: '/api/v2/user',
    userAvatar: '/api/v2/user/avatar',
}